const TRADE_NPC_PORTRAIT_VARIANTS = new Set(["detail", "hover", "list", "query"]);

function escapeHtml(value) {
  return String(value ?? "").replace(
    /[&<>"']/g,
    (char) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      })[char] || char,
  );
}

function trimString(value) {
  const normalized = String(value ?? "").trim();
  return normalized || "";
}

export function tradeNpcPortraitMarkup({
  imageUrl = "",
  badgeImageUrl = "",
  badgeLabel = "Imperial Fishing Delivery",
  name = "NPC",
  variant = "list",
} = {}) {
  const normalizedVariant = trimString(variant);
  if (!TRADE_NPC_PORTRAIT_VARIANTS.has(normalizedVariant)) {
    throw new TypeError(`Unsupported Trade NPC portrait variant: ${normalizedVariant || "missing"}`);
  }
  const normalizedName = trimString(name) || "NPC";
  const normalizedImageUrl = trimString(imageUrl);
  const className = `fishymap-trade-npc-portrait fishymap-trade-npc-portrait--${normalizedVariant}`;
  const portrait = normalizedImageUrl
    ? `<img class="${className}" src="${escapeHtml(normalizedImageUrl)}" alt="${escapeHtml(normalizedName)}" loading="lazy" decoding="async">`
    : `<span class="${className} fishymap-trade-npc-portrait--fallback" aria-hidden="true">${escapeHtml(Array.from(normalizedName)[0]?.toUpperCase() || "?")}</span>`;
  const normalizedBadgeImageUrl = trimString(badgeImageUrl);
  if (!normalizedBadgeImageUrl) {
    return portrait;
  }
  return `<span class="fishymap-trade-npc-portrait-stack fishymap-trade-npc-portrait-stack--${normalizedVariant}">${portrait}<img class="fishymap-trade-npc-class-badge" src="${escapeHtml(normalizedBadgeImageUrl)}" alt="${escapeHtml(trimString(badgeLabel) || "Imperial Fishing Delivery")}" loading="lazy" decoding="async"></span>`;
}
